import { CheckboxQuestionConfig } from '@gripp/shared-logic';
import { OptionList, RuledLines } from '../components/printPrimitives';
import { RoutinePrintQuestion } from './types';

export const CheckboxPrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const checkbox = config as CheckboxQuestionConfig;
  const options = checkbox.options ?? [];

  if (options.length === 0) return <RuledLines />;

  return <OptionList options={options} glyph="check" />;
};
